import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
import { KonfirmasiHapusComponent } from 'src/app/shared/state/konfirmasi-hapus/konfirmasi-hapus.component';
import { UserLapanganAddComponent } from 'src/app/user-lapangan/user-lapangan-add/user-lapangan-add.component';
import { NavigationExtras, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormBuilder,FormGroup } from '@angular/forms';
import { DetailHasilSurveyComponent } from '../detail-hasil-survey/detail-hasil-survey.component';

@Component({
  selector: 'app-hasil-survey',
  templateUrl: './hasil-survey.component.html',
  styleUrls: ['./hasil-survey.component.css']
})
export class HasilSurveyComponent implements OnInit {

 
  page: any = 1;

  fractionSize;
  ionicForm: FormGroup;
  isSubmitted = false;
  nn: any = '';
  form: any = '';
  

  user: any;
  token: any;
  hasil: any;
  load: boolean = false;

  leadn: any = {};
  lnores: any;
  aa: any;

  opsi: boolean = false;
  totalCekData: any;
  pageInfo: any = {};
  pageNation: any;

  viewType: any;

  filter: any = '';
  filterr: any = '';

  resAr: any;
  add: any = {};

  leadnHapus: any = {};

  kinfo: any = {};
  dataInfo: any;

  isIndeterminate:boolean;
  masterCheck:boolean;
  checkBoxList:any;

  cabang: any = '';
  tenor: any = '';
  agunan: any = '';
  plafon: any = '';
  kolektor: any = '';

  baseUrl: any = '';
  usertoken: any = '';

  users: any;
  parent: any = {};
  children: any = {};
  action: any;

  act1: any;
  act2: any;
  act3: any;

  dateRange: any = '';
  filterDaterange: any = [];

  tampilDateRange: boolean = false;
  resetInput: boolean = false;

  pending_survey: any = '0';
  finish_survey: any = '0';
  startDate: any = '';
  endDate: any = '';

  userX : any = '';

  constructor(
    public util: UtilService,
    public api: ApiService,
    public modalController: ModalController,
    public router: Router,
    public http: HttpClient,
    public formBuilder: FormBuilder,

  ) {
    this.baseUrl = environment.restURL.baseUrl;
    this.usertoken = localStorage.getItem('usertoken') || 'null';

  }

  submitForm(){
    console.log('FORM',this.ionicForm.value);
    this.nn = this.ionicForm.value.name;
    this.isSubmitted = true;
    if (!this.ionicForm.valid) {
      console.log('Please provide all the required values!')
      return false;
    } else {
      console.log('Keyboard',this.nn);
      this.res();
    }
  }

  ngOnInit() {
    this.ionicForm = this.formBuilder.group({
      name: ['']
    });
    this.addx();
  }

  addx(){
    this.users = this.api.getUserMenu();

    try {
      this.parent = this.users.find((item: any) => item.menu_id === 'Kolektor');
      this.children = this.parent.childrens.find((item: any) => item.id === 'Kontrak Lunas');
      this.action = this.children.actions;
      console.log(this.users);
      console.log(this.children);
      console.log(this.action);

      this.act1 = this.action.find((item: any) => item === 'Laporan tiap cabang');
      this.act2 = this.action.find((item: any) => item === 'Export');
      // this.act3 = this.action.find((item: any) => item === 'Hapus Pegawai');
      console.log('act2',this.act2)
    } catch (error) {
      console.log('error',error)
    }
  }

  ionViewWillEnter() {
    this.page = 1;
    this.res();
  }
  
  handleSelection(selectedValue: string, model: any) {
    if (model == 'cabang') {
      this.cabang = selectedValue;
    } else if (model == 'tenor') {
      this.tenor = selectedValue;
    } else if (model == 'agunan') {
      this.agunan = selectedValue;
    } else if (model == 'plafon') {
      this.plafon = selectedValue;
    } else if (model == 'kolektor') {
      this.kolektor = selectedValue;
    } else if (model == 'dateRange') {
      this.dateRange = selectedValue;
    }
    this.res()
  }

  daterangeFilter(selectedValue: string, model: any){
    console.log('selectedValue',selectedValue);
    console.log('dateRange',this.dateRange);
    const [startDateString, endDateString] = selectedValue.split(' - ');
    const dateArray = [startDateString, endDateString];
    this.filterDaterange = dateArray;
    console.log('filterDaterange',this.filterDaterange);
    this.startDate = startDateString;
    this.endDate = endDateString;
    this.res()
  }

  reset(){
    this.tenor = '';
    this.agunan = '';
    this.plafon = '';
    this.kolektor = '';
    this.dateRange = '';
    this.filterDaterange = [];
    this.cabang = '';
    this.nn = '';
    this.startDate = '';
    this.endDate = '';
    this.userX = '';
    this.resetInput = !this.resetInput;
    this.ionicForm = this.formBuilder.group({
      name: ['']
    });
    this.res();
  }

  dateR(){
    console.log('dateRange',this.dateRange)
    this.tampilDateRange = false;
    this.tampilDateRange = true;

  }
  
  checkMaster() {
    setTimeout(()=>{
      this.lnores.forEach(obj => {
        obj.isChecked = this.masterCheck;
      });
    });
    
  }

  checkEvent() {
    const totalItems = this.lnores.length;
    let checked = 0;
    this.lnores.map(obj => {
      if (obj.isChecked) checked++;
    });
    if (checked > 0 && checked < totalItems) {
      //Check Satu
      this.isIndeterminate = true;
      this.masterCheck = false;
      this.aa = this.lnores.filter((value, index) => {
        return value.isChecked
      });
      this.opsi = true;
    } else if (checked == totalItems) {
      //Check Semua
      this.masterCheck = true;
      this.isIndeterminate = false;
      this.aa = this.lnores.filter((value, index) => {
        return value.isChecked
      });
      this.opsi = true;
    } else {
      //Uncheck
      this.isIndeterminate = false;
      this.masterCheck = false;
      this.aa = '';
      this.opsi = false;
    }
    console.log('aa',this.aa);
    console.log('opsi',this.opsi);
   this.totalCekData = checked;
   this.resAr = { id: this.aa.map(obj => obj.contract_id) };
    console.log('resAr',this.resAr);
  }

  
  avail() {
    // this.load = true;
    // this.api.get('backoffice/kuota/info/available')
    //   .subscribe((data) => {
    //     this.kinfo = data;
    //     if (this.kinfo.error == 0) {
    //       this.load = false;
    //       // this.tambah();
    //     } else {
    //       this.load = false;
    //       this.util.showToast(this.kinfo.message, 'danger', 'bottom');
    //     }
    //   }, (error) => {
    //     this.load = false;
    //     console.log('error', error);
    //     this.api.errorCond(error)
    //   });

  }

  async next(data: any) {
    // const modal = await this.modalController.create({
    //   component: KolektorPenagihanImportNextComponent,
    //   cssClass: 'modalDataImport',
    //   componentProps: {
    //     id: data
    //   }
    // });
    // modal.onDidDismiss()
    //   .then((data: any) => {
    //     if (data.role === 'confirm') {
    //       this.ionViewWillEnter();
    //     }else if(data.role === 'duplicate'){
          
    //     }
    //   });
    // return await modal.present();
  }

  async import() {
    // const modal = await this.modalController.create({
    //   component: KolektorPenagihanImportComponent,
    //   cssClass: 'modalBankForm',
    //   // componentProps: {
    //   //   id: id
    //   // }
    // });
    // modal.onDidDismiss()
    //   .then((data: any) => {
    //     if (data.role === 'confirm') {
    //       this.ionViewWillEnter();
    //     }else if(data.role === 'duplicate'){
    //       this.next(data.data);
    //     }
    //   });
    // return await modal.present();
  }

  async tambah(id: any) {
    // const modal = await this.modalController.create({
    //   component: KolektorPenagihanAddComponent,
    //   cssClass: 'modalBankForm',
    //   componentProps: {
    //     id: id
    //   }
    // });
    // modal.onDidDismiss()
    //   .then((data: any) => {
    //     if (data.role === 'confirm') {
    //       this.ionViewWillEnter();
    //     }
    //   });
    // return await modal.present();
  }


  async tambahBulk() {
    // const modal = await this.modalController.create({
    //   component: KolektorPenagihanAddComponent,
    //   cssClass: 'modalForm',
    //   componentProps: {
    //     ids: JSON.stringify(this.resAr.id)
    //   }
    // });
    // modal.onDidDismiss()
    //   .then((data: any) => {
    //     if (data.role === 'confirm') {
    //       this.ionViewWillEnter();
    //     }
    //   });
    // return await modal.present();
  }

  async konfHapus(id) {
    // const modal = await this.modalController.create({
    //   component: KonfirmasiHapusComponent,
    //   cssClass: 'modalConfirmation',
    //   componentProps: {
    //     image: 'assets/imgs/konfirmasi-hapus.svg',
    //     title: 'Hapus data?',
    //     desc: 'Data yang telah dihapus tidak bisa dikembalikan lagi',
    //     button: '2'
    //   }
    // });
    // modal.onDidDismiss()
    //   .then((data: any) => {
    //     if (data.role === 'confirm') {
    //       this.hapus(id);
    //     }
    //   });
    // return await modal.present();
  }

  detail(id: any) {
    // let navigationExtras: NavigationExtras = {
    //   queryParams: {
    //     no: id,
    //   }
    // };
    // this.router.navigate(['./kolektor-penagihan-detail'], navigationExtras);

  }

  downloadExcel() {
    let a = {
      lead_id: this.nn,
    }
    let filter = {
      branch_id: this.cabang,
      _tenor_id: this.tenor,
      agunan: this.agunan,
      _contract_date_between: this.filterDaterange,
      submission_loan_between: this.plafon,
      collector: this.kolektor
    }
    this.form = {
      from:'v_backoffice_kontrak_lunas_list',
      q: a,
      // x_page: this.page,
      and: filter
      // // limit:6
    };
    const url = this.baseUrl+'download/excel';
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.usertoken,
    });

    this.http.post(url, this.form, {
      headers: headers,
      responseType: 'arraybuffer', 
    })
    .subscribe((data: ArrayBuffer) => {
      this.saveExcelFile(data); 
    }, (error) => {
      console.error('Error downloading Excel file:', error);
    });
  }

  saveExcelFile(data: ArrayBuffer) {
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'excel_file.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  async XXexpor() {
    // console.log(src);
    // this.loaddownload1 = true;
    let a = {
      name: this.nn,
    }
    let filter = {
      branch_id: this.cabang,
      _tenor_id: this.tenor,
      agunan: this.agunan,
      submission_loan_between: this.plafon,
      collector: this.kolektor
    }
    this.form = {
      from:'v_backoffice_kontrak_lunas_list',
      q: a,
      page: this.page,
      and: filter
      // // limit:6
    };
    let fetchOptions = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + this.token,
      },
      body: this.form,
    };
    var that = this;
    fetch(
      'https://apidev.jetapps.id/v001/download/excel',
      fetchOptions
    )
      .then((response) => response.blob())
      .then((imageBlob) => {
        const reader = new FileReader();
        // this.loaddownload1 = false;
        reader.onloadend = () => {
          // that.linkdownload1x = reader.result;
          // that.linkdownload1 = this.dom.bypassSecurityTrustUrl(that.linkdownload1x) as string;
          // console.log('linkdownload1', that.linkdownload1);
          // that.preview(that.linkdownload1);
          const a = document.createElement('a');
          const objectUrl = URL.createObjectURL(imageBlob)
          a.href = objectUrl
          a.download = name + '_' + 'asdasdas' + '.xlsx';
          a.click();
          URL.revokeObjectURL(objectUrl);
        };
        reader.readAsDataURL(imageBlob);
      });
  }

  expor() {
    this.load = true;
    let a = {
      contract_id: this.nn,
    }
    let filter = {
      branch_id: this.cabang,
      _tenor_id: this.tenor,
      agunan: this.agunan,
      submission_loan_between: this.plafon,
      collector: this.kolektor
    }
    this.form = JSON.stringify({
      from:'v_backoffice_kontrak_lunas_list',
      q: a,
      page: this.page,
      and: filter
      // // limit:6
    });
    this.api.postExcel('download/excel',this.form)
      .subscribe((data: Blob) => {
        this.leadnHapus = data;
        window.open(this.leadnHapus);
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
  }

   async detailxx(p: any) {
      const modal = await this.modalController.create({
        component: DetailHasilSurveyComponent,
        cssClass: 'wd-assignXX',
        componentProps: {
          datax: p,
        },
      });
      modal.onDidDismiss().then((data) => {
        if (data.role === 'confirm') {
        }else{
        }
      });
      return await modal.present();
    }

  res() {
    this.load = true;
    this.api.get('backoffice/reports/surveyor?page='+this.page+'&limit=20&keyword='+this.nn+'&branch_id='+this.cabang+'&user_id='+this.userX+'&start_date='+this.startDate+'&end_date='+this.endDate)
      .subscribe((data) => {
        this.leadn = data;
        if (this.leadn.error == 0) {
          this.load = false;
            this.lnores = this.leadn.data.rows;
            this.finish_survey = this.leadn.data.summary.finish_survey;
            this.pending_survey = this.leadn.data.summary.pending_survey;
            this.pageInfo = this.leadn.data;
          // }
        } else {
          this.load = false;
          this.util.showToast(this.leadn.message, 'success', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
  }

  firstPage() {
    this.page = 1;
    this.res();
  }

  prevPage() {
    this.page = this.page -= 1;
    this.res();
  }

  nextPage() {
    this.page = this.page + 1;
    this.res();
  }

  lastPage() {
    this.page = this.pageInfo.total_pages;
    this.res();
  }


}
